import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import iOS from '../views/iOS.vue'
import Android from '../views/Android.vue'
import GuideIOS from '../views/GuideIOS.vue'
import GuideAndroid from '../views/GuideAndroid.vue'
import FashionIOS from '../views/FashionIOS.vue'
import FashionAndroid from '../views/FashionAndroid.vue'
import HealthIOS from '@/views/HealthIOS.vue'
import SparkleCloudAnimeIOS from '../views/SparkleCloudAnimeIOS.vue'
import SparkleCloudAnimeAndroid from '../views/SparkleCloudAnimeAndroid.vue'
import MilaRememberMV from '../views/MilaRememberMV.vue'
import ItMonth25Summary from '../views/ItMonth25Summary.vue'
import GuideSummary from '../views/GuideSummary.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/ios',
    name: 'iOS',
    component: iOS
  },
  {
    path: '/android',
    name: 'Android',
    component: Android
  },
  {
    path: '/guide_ios',
    name: 'GuideIOS',
    component: GuideIOS
  },
  {
    path: '/guide_android',
    name: 'GuideAndroid',
    component: GuideAndroid
  },
  {
    path: '/fashion_ios',
    name: 'FashionIOS',
    component: FashionIOS
  },
  {
    path: '/fashion_android',
    name: 'FashionAndroid',
    component: FashionAndroid
  },
    {
    path: '/health_ios',
    name: 'HealthIOS',
    component: HealthIOS
  },
  {
    path: '/sparklecloud_anime_ios',
    name: 'SparkleCloudAnimeIOS',
    component: SparkleCloudAnimeIOS
  },
  {
    path: '/sparklecloud_anime_android',
    name: 'SparkleCloudAnimeAndroid',
    component: SparkleCloudAnimeAndroid
  },
  {
    path: '/mila_remember_mv',
    name: 'MilaRememberMV',
    component: MilaRememberMV
  },
  {
    path: '/itmonth25/summary/:xxxxx',
    name: 'ItMonth25Summary',
    component: ItMonth25Summary
  },
  {
    path: '/guide/summary/:xxxxxxx',
    name: 'GuideSummary',
    component: GuideSummary
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
